<template>
  <div style="width:100%">
    <div v-if="comment_info && show_comment" class="average_rating commentModule" style="padding:20px 0;margin-bottom:10px;">
    <v-comments-star :disabled="true" :average_rating="average"></v-comments-star>
    <span class="secondary_title" v-cloak> {{total_comment > comment_info.count ? comment_info.count:total_comment}} {{$t('comment.reviews')}}</span>
    </div>
  <div class="commentsItemBox" :class="{'commentModule':comment_info || product_review}">
    <v-comments-flat  v-if="comment.template != 'waterfall' && comment_mode !== 'page' && current_theme !='athena'"
    :comment_mode='comment_mode' :comment='comment' :new_comments_list='new_comments_list' :showBigImg="showBigImg"
    :comment_helpful="comment_helpful" :click_abuse="click_abuse"></v-comments-flat>

    <!-- ahtena平铺模式 -->
    <v-comments-flat-update
    v-if="comment.template != 'waterfall' && comment_mode !== 'page' && current_theme == 'athena'"
    :comment_mode='comment_mode'
    :comment='comment'
    :new_comments_list='new_comments_list'
    :showBigImg="showBigImg"
    :comment_helpful="comment_helpful"
    :click_abuse="click_abuse"
    :review_count="review_count"
    :average_rating="average_rating"
    :rating_count="rating_count"
    :product_id="product_id"
    :product_review="product_review"
    :get_comment="get_comment"
    :last_page="last_page"
    :next_page="next_page"
    >
    </v-comments-flat-update>

    <v-comments-waterfall  v-if="comment.template == 'waterfall' || comment_mode == 'page'"
    :comment_mode='comment_mode' :comment='comment' :new_comments_list='new_comments_list' :showBigImg="showBigImg"
    :comment_helpful="comment_helpful" :click_abuse="click_abuse" @cardClick="handCardClick" :comment_info="comment_info"></v-comments-waterfall>

    <div
      class="pagination"
      v-if="comments_list_length > comment.count - 0 && comment_mode !== 'page'"
    >
      <el-pagination
        :background="true"
        :small="pagination_size"
        layout="prev, pager, next"
        @current-change="changepage"
        :total="comments_list_length"
        :page-size="comment.count - 0"
        :pager-count="pagerCount"
      ></el-pagination>
    </div>
    <div
      v-if="comment_mode === 'page' && next_page <= last_page && !comment_info"
      style="text-align: center; padding-top: 40px; padding-bottom: 40px"
    >
      <span class="more_reviews_btn secondary_title" @click="get_comment(next_page)">
        {{ $t('comment.show_more_reviews') }}
      </span>
    </div>
    <div
      v-if="comment_mode === 'page' && comment_info"
      class="comment_btn"
        :style="{
          '--button-limit-pc':comment_info.limit_pc,
          '--button-limit-mobile':comment_info.limit_mobile,}"
    >
      <span
      v-if="comment_info.show_more_button && next_page <= last_page && show_more"
      :style="{background: comment_info.button_background_color,color:comment_info.button_text_color}"
      class="more_reviews_btn secondary_title"
      :class="{'link_button_zoom':comment_info.limit_pc||comment_info.limit_mobile}"
      @click="get_comment(next_page)">
        {{ $t('comment.show_more_reviews') }}
      </span>
      <a
      v-if="customBtnHref()"
      class="more_reviews_btn secondary_title"
      :class="{'link_button_zoom':comment_info.limit_pc||comment_info.limit_mobile}"
      :style="{background: comment_info.button_background_color,color:comment_info.button_text_color,borderColor: comment_info.button_background_color}"
      :href="customBtnHref()"
      @click="moduleLink()"
      >
        {{comment_info.show_custom_button.text}}
      </a>
    </div>
    <el-dialog custom-class="commentsItemBox__dialog" width="600px" :title="$t('comment.warning')" :visible.sync="dialogVisible">
      <span class="page_text_font">
        <i class="iconfont icon-cm-2" style="color: red"></i>
        {{ $t("comment.inappropriate") }}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="secondary_title"
          @click="dialogVisible = false"
          style="background: white; border: 1px solid #dcdfe6; color: #606266"
          >{{ $t("comment.cancel") }}</el-button
        >
        <el-button
          type="primary"
          class="main_button secondary_title"
          @click="comment_abuse"
          :loading="loading"
          >{{ $t("comment.confirm") }}</el-button
        >
      </span>
    </el-dialog>
    <v-product-big-img
      v-if="bigImgOnOff"
      @hideBigImg="hideBigImg"
      :bigImgGallery="bigImgGallery"
      :bigImgGalleryIndex="bigImgGalleryIndex"
    ></v-product-big-img>
    <v-comments-modal
      :comment_mode="comment_mode"
      :comment="comment"
      :comment_item="comment_item"
      :modal_index="modal_index"
      @change_modal_index="change_modal_index"
    ></v-comments-modal>
  </div>
  </div>
</template>
<script>
import vCommentsStar from "./commentsstar";
import vProductBigImg from "./productBigImg";
import vCommentsModal from "./commentModal";
import vCommentsFlat from "./commentsUl_flat.vue";
import vCommentsFlatUpdate from "./commentsUl_flat_update.vue";
import vCommentsWaterfall from "./commentsUl_waterfall.vue";
export default {
  props: ["comment", "comments", "product_id", "comment_mode", "comment_info", "product_review", "review_count", "average_rating", "rating_count"],
  data() {
    return {
      show: true,
      comments_list: [],
      new_comments_list: [],
      comments_list_length: [], //详情页评论数量总数
      current_page: 1,
      dialogVisible: false,
      loading: false,
      comment_item: {}, //点击举报的时候用的单挑评论
      comment_index: {}, //点击举报的时候用的单挑评论
      bigImgOnOff: false,
      bigImgGallery: [],
      bigImgGalleryIndex: 0,
      last_page: 0,
      next_page: 1,
      btn_active: false,
      pagerCount: 7,
      modal_index: 1,
      pagination_size: false,
      show_more: true,
      average: '0.00',
      total_comment: 0,
      show_comment:false,
      current_theme:null,
    };
  },
  methods: {
    changeBigImgIndex(index) {
      this.bigImgGalleryIndex = index;
    },
    change_modal_index(index) {
      this.modal_index = index;
    },
    handCardClick(index, item) {
      this.comment_item = item;
      this.modal_index = 1;
      this.$("#commentModal").modal("show");
    },
    async get_comment(page = 1, popup) {
      if (this.btn_active) return;
      try {
        this.btn_active = true;
        let params = {
          page,
          "filter[visible]": true,
          "filter[approving]": "yes",
          "filter[product_comment_status]": true,
          "sort" : '-comment_date',
        };
        if(this.comment_info && this.comment_info.only_image_comment) {
           params['filter[gallery]']=true;
        }
        if(this.comment_info && this.comment_info.count) {
           params.count=this.comment_info.count;
        }
        if (this.comment_mode == "page") {
          params.page_size = 20;
          params["filter[on_sale_product]"] = true;
        } else {
          params.page_size = this.comment.count;
          params["filter[product_id]"] = this.product_id;
          params["sort"] = "-top_date";
        }
        let res = await this.$axios.get("/api/store/comments", { params });
        this.btn_active = false;
        if (res && res.data && res.data.data && res.data.data.length) {
          if (this.comment_mode == "page" || popup) {
            this.new_comments_list = [
              ...new Set(this.new_comments_list.concat(res.data.data)),
            ];
            if(popup) {
              this.new_comments_list = this.new_comments_list.map((item) => {
              item.help_show = true;
              return item;
            });
            }
            this.show_comment = true;
          if(this.comment_info){
             this.average=res.data.average;
             this.total_comment=res.data.meta && res.data.meta.total || 0;
          }
          if(this.comment_info && this.comment_info.count && this.comment_info.count <= this.new_comments_list.length) {
             this.new_comments_list.length = this.comment_info.count;
             this.show_more=false;
          }
            this.last_page = res.data.meta.last_page;
            this.next_page++;
          } else {
            this.comments_list_length = res.data.meta.total;
            this.new_comments_list = res.data.data.map((item) => {
              item.help_show = true;
              item.abuse_show = true;
              return item;
            });
            console.log(
              this.new_comments_list,
              "this.new_comments_listthis.new_comments_list"
            );
          }
        } else {
          this.new_comments_list = [];
        }
      } catch (error) {
        this.btn_active = false;
        if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    },
    hideBigImg() {
      this.bigImgOnOff = false;
      this.$("body").css({ overflowY: "" });
    },
    showBigImg(gallery, index) {
      this.$("body").css({ overflowY: "hidden" });
      this.bigImgOnOff = true;
      this.bigImgGallery = gallery;
      this.bigImgGalleryIndex = index;
    },
    click_abuse(item, index) {
      this.dialogVisible = true;
      this.comment_item = item;
      this.comment_index = index;
    },
    async comment_abuse() {
      this.loading = true;
      if (this.comment_item.add_comment) {
        this.comment_item.abuse_show = false;
        this.dialogVisible = false;
        this.loading = false;
        return;
      }
      try {
        let res = await this.$axios.post(
          `/api/store/comments/${this.comment_item.comment_ID}/abuse`,
          {
            ip: this.$store.state.ipinfo.ip,
          }
        );
        if (res.status == 200) {
          this.comment_item.abuse_show = false;
          this.$set(
            this.new_comments_list,
            this.comment_index,
            this.comment_item
          );
        }
      } catch (error) {
        if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
      this.dialogVisible = false;
      this.loading = false;
    },
    async comment_helpful(e, index) {
      if (e.add_comment) {
        e.help_show = false;
        this.$set(this.new_comments_list, index, e);
        return;
      }
      try {
        let res = await this.$axios.post(
          `/api/store/comments/${e.comment_ID}/thumbup`,
          {
            ip: this.$store.state.ipinfo.ip,
          }
        );
        console.log(res);
        if (res.status == 200) {
          e.help_show = false;
          e.like_account = res.data.like_account || 0
          this.$set(this.new_comments_list, index, e);
        }
      } catch (error) {
        if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    },
    changepage(e) {
      this.get_comment(e);
      this.$("html, body").animate(
        {
          scrollTop: this.$("div.container.comments").offset().top,
        },
        500
      );
    },
    customBtnHref() {
      if(this?.comment_info?.show_custom_button?.show && this?.comment_info?.show_custom_button?.text) {
        if(this.comment_info.show_custom_button?.type == 'point' && this.comment_info.show_custom_button.point_target) {
           return 'javascript:;'
        }
        return this.comment_info.show_custom_button?.type == 'link' && this.comment_info.show_custom_button.url || !this.comment_info.show_custom_button?.type && this.comment_info.show_custom_button.url;
      }
      return false;
    },
    moduleLink() {
      if(this?.comment_info?.show_custom_button?.type == 'point' && this?.comment_info?.show_custom_button?.point_target) {
        moduleScroll(this.comment_info.show_custom_button.point_target);
      }
    }
  },
  beforeMount() {
    if (window.innerWidth < 768) {
      this.pagination_size = true;
    }
    this.current_theme = this.$store.state?.options?.theme?.name;
  },
  mounted() {
    if(this?.comment?.template != 'waterfall' && this.comment_mode !== 'page' && this.current_theme == 'athena') {
      this.get_comment(1,'popup');
    }
    else {
      this.get_comment(1);
    }
  },
  components: {
    vCommentsStar,
    CountryFlag: resolve => {require(['vue-country-flag'], resolve)},
    vProductBigImg,
    vCommentsModal,
    vCommentsWaterfall,
    vCommentsFlat,
    vCommentsFlatUpdate,
  },
  watch: {
    "$store.state.new_comment"() {
      this.comments_list.unshift(this.$store.state.new_comment);
      if (this.current_page == 1) {
        this.new_comments_list = this.comments_list.slice(0, 8);
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.commentsItemBox {
  &::v-deep {
    .commentsItemBox__dialog {
      max-width: calc(100vw - 30px);
    }
  }

  .pagination {
    display: flex;
    justify-content: center;
    &::v-deep .el-pager {
      .active {
        background-color: var(--main-btn-bg) !important;
        color: var(--main-btn-tx) !important;
      }
    }
  }
  .more_reviews_btn {
    font-size: 12px;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    border-radius: 2px;
    transition-property: "background", "color";
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;
    &:hover {
      background: #282828;
      color: #fff;
      outline: 0;
    }
  }
}
.commentModule {
   &::v-deep {
     .commentsUl_waterfall {
         margin: 0 -15px !important;
         column-gap: 0;
          > li {
           padding : 15px !important
         }
      .person_info {
         .detail {
           line-height: 20px !important;
         }
         .star {
           margin:10px 0 !important;
         }
         .country_time {
           height: auto !important;
         }
      }
       .waterfall_box {
         background-color: #f0f0f0 !important;
         box-shadow: none !important;
         border-radius: unset;
       }
       .waterfall_main {
           padding: 20px !important;
       }
       .comment_pro {
         padding: 20px !important;
         display: none;
       }
       .comment-reply {
           padding: 0 21px 25px 21px !important;
          .comment-reply-main li {
             margin-top: 0;
             padding-top: 20px;
             .comment-reply-title {
                line-height: 24px;
             }
             p {
               line-height: 20px;
             }
          }
       }
       .waterfall_commentsphoto {
         width: 100%;
         img {
           width: 100%;
         }
       }
       .comment-reply-main .time{
            display: none;
       }
     }
     .el-rate {
       height: auto;
     }
     .el-rate__item {
       margin-right: 3px !important;
     }
     .el-rate__icon {
        color: #000 !important;
        font-size: 20px !important;
      }
     .el-rate__decimal {
        color: #000 !important;
     }
     .comment_btn {
      text-align: center;
      padding-top: 40px;
      padding-bottom: 40px;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
     .more_reviews_btn {
      font-size: 16px !important;
      padding: 21px 33px !important;
      width: 270px;
      margin-top: 10px;
     }
    }
@media screen and(max-width: 1180px) {
  .commentsUl_waterfall {
    column-count: 3 !important;
  }
}
@media screen and(max-width: 768px) {
  .comment_btn {
   .more_reviews_btn {
    font-size: 14px !important;
    width: 240px;
   }
  }
  .commentsUl_waterfall {
    column-count: 2 !important;
    margin: 0 -7.5px !important;
     > li {
      padding : 10px 7.5px !important
    }
    .person_info {
    .detail {
      line-height: 20px !important;
      font-size: 13px !important;
    }
    .star {
      margin:15px 0 !important;
    }
    }
    .waterfall_main {
         padding: 10px 11.5px 15px 10px!important;
    }
    .comment-reply {
         padding: 0 11.5px 15.5px 10px !important;
        .comment-reply-main li {
           margin-top: 0;
           padding-top: 15px;
           .comment-reply-title {
              line-height: 21px;
              font-size: 15px;
           }
           p {
             line-height: 18px;
             font-size: 13px;
           }
        }
     }
  }
  .el-rate__item {
    margin-right: 0px !important;
  }
  .el-rate__icon {
     color: #000 !important;
     font-size: 10px !important;
  }
}
@media screen and(max-width: 575px) {
  .comment_btn {
       flex-direction: column;
       align-items: center;
  }
}
   }

}

@media screen and(max-width: 768px) {
.average_rating {
  padding: 0 !important;
}
}


</style>
